import { useMutation } from '@tanstack/react-query';
import { ProjectAttributesAPI } from '@newo/api/gateway';
import type { TAttributeData } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const projectAttributesAPI = new ProjectAttributesAPI(axios);

export const useCreateProjectAttributesMutation = () => {
    return useMutation({
        mutationFn: async ({
            projectId,
            data
        }: {
            projectId: string;
            data: TAttributeData;
        }) => projectAttributesAPI.createProjectAttribute(projectId, data)
    });
};

export const useUpdateProjectAttributesMutation = () => {
    return useMutation({
        mutationFn: async ({
            projectId,
            attributeId,
            data
        }: {
            projectId: string;
            attributeId: string;
            data: TAttributeData;
        }) =>
            projectAttributesAPI.updateProjectAttribute(
                projectId,
                attributeId,
                data
            )
    });
};

export const useDeleteProjectAttributesMutation = () => {
    return useMutation({
        mutationFn: async ({
            projectId,
            attributeId
        }: {
            projectId: string;
            attributeId: string;
        }) =>
            projectAttributesAPI.deleteProjectAttribute(projectId, attributeId)
    });
};
